import { Layout, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';

const StyledText = styled(Text)`
  margin-bottom: ${(props) => props.theme.size.static350};
`;

export function NoDateSelectedModalContentVwView(): ReactElement {
  return (
    <Layout>
      <StyledText appearance={TokenTextAppearance.headline400} bold>
        Appointment date required
      </StyledText>
      <Text>Please select an appointment date to continue.</Text>
    </Layout>
  );
}
